


import SECTION_1676449885066 from
'../dynamic_section/dynamic_2/template_01';






import Shop from '../sections/shop/template_01';






import SECTION_SHOPCONTAINER_1 from
'../dynamic_section/dynamic_1/template_01';


import SpeakerAnnouncement from '../sections/speaker_announcement/template_01';



import SECTION_SHOPCONTAINER_2 from
'../dynamic_section/dynamic_1/template_01';





import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const shopPage = ()=>{
return (
  <div id="shopPage" class="page ">
  
  

  
  < SECTION_1676449885066 desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `shop_title` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />

   < SECTION_1676449885066 desktopToggle={ false }
    mobileToggle={ true } label={ `Dynamic Section2` } id={ `shop_title_m` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  
  <SpeakerAnnouncement desktopToggle={ true } mobileToggle={
    true } iconToggle={ true } titleToggle={
    false } />
  

  
  <Shop desktopTitleToggle={ false }
    mobileTitleToggle={ false } />
  
  
  
  

  
  < SECTION_SHOPCONTAINER_1 desktopToggle={ true }
    mobileToggle={ true } label={ `shopContainer` } id={ `Section_shopContainer` }
    imageSize={`1x1`} contentPosition={`bottom`}
    actionPosition={`bottom`} rowDesktop={ 5 }
    rowMobile={ 2 } numberOfRow={ -1 }
    dataType={`product`} noPadding={ false } filter={``}
    titleToggle={ false } titleIconToggle={ true }
    cardPosition={``} pagination={ true }
    autoplay={ true } navigation={ true }
    dynamicQuery={`` } filterTabToggle={ true }
    folderImage={``} noLink={ false }/>
  
  
  

  
  
  

  

  
  
</div>
)
}

export default shopPage;